module.exports = __webpack_public_path__ + "Participant Notice 7_12_2024.pdf";